import { render, staticRenderFns } from "./draggableDynamicTableSetting.vue?vue&type=template&id=1de82ec4&"
import script from "./draggableDynamicTableSetting.vue?vue&type=script&lang=js&"
export * from "./draggableDynamicTableSetting.vue?vue&type=script&lang=js&"
import style0 from "./draggableDynamicTableSetting.vue?vue&type=style&index=0&id=1de82ec4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports